import React, { useRef } from 'react'
import ClickableImageCard from '../custom-components/ClickableImageCard';
import './HC.css'

function HomeChecklist() {

    const carouselRef = useRef(null);
            
            const scroll = (direction) => {
                const scrollAmount = 300;
                carouselRef.current.scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth'
                });
            };

            const deals = [
                {id: 1, bboo: "one", image: "https://assets.tatacliq.com/medias/sys_master/images/63588845387806.png"},
                {id: 2, bboo: "two", image: "https://assets.tatacliq.com/medias/sys_master/images/63588845453342.png"},
                {id: 3, bboo: "three", image: "https://assets.tatacliq.com/medias/sys_master/images/63588845518878.png"},
                {id: 4, bboo: "four", image: "https://assets.tatacliq.com/medias/sys_master/images/63588845584414.png"},
                {id: 5, bboo: "five", image: "https://assets.tatacliq.com/medias/sys_master/images/63588845649950.png"},
                {id: 6, bboo: "six", image: "https://assets.tatacliq.com/medias/sys_master/images/63588845715486.png"},
            ];
            return (
                <div className="carousel-container">
                  <div className="carousel-controls justify-content-end mb-5">
                      <button onClick={() => scroll('left')} className="control-button">
                        &lt;
                      </button>
                      <button onClick={() => scroll('right')} className="control-button">
                        &gt;
                      </button>
                    </div>
                  
                  <div className="image-carousel" ref={carouselRef}>
                    {deals.map((deal) => (
                      <ClickableImageCard key={deal.id} item={deal} />
                    ))}
                  </div>
                </div>
              );
}

export default HomeChecklist